import { motion } from 'framer-motion'

import CircleIcon from '@/assets/icons/circle.svg?react'
import XMarkIcon from '@/assets/icons/x.svg?react'

import { BackButton, ContentArea, ResultIconWrapper, ResultLabel, ResultText, StepWrapper, TextGroup } from './styles'

const ICON_DELAY_S = 0.05
const TEXT_DELAY_S = 0.35
const BUTTON_DELAY_S = 0.5

interface ResultStepProps {
  isCorrect: boolean
  resultText: string
  onBack: (showEnergyToast?: boolean) => void
}

export default function QuizResultStep({ isCorrect, resultText, onBack }: ResultStepProps) {
  return (
    <StepWrapper initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.15 }}>
      <ContentArea>
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: [0, 1.15, 0.93, 1] }}
          transition={{ delay: ICON_DELAY_S, duration: 0.3, ease: 'easeOut' }}
        >
          <ResultIconWrapper isCorrect={isCorrect}>
            {isCorrect ? (
              <CircleIcon style={{ color: '#3b82f6' }} width={32} height={32} />
            ) : (
              <XMarkIcon style={{ color: '#ef4444' }} width={32} height={32} />
            )}
          </ResultIconWrapper>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: TEXT_DELAY_S, duration: 0.25, ease: 'easeOut' }}
        >
          <TextGroup>
            <ResultLabel isCorrect={isCorrect}>{isCorrect ? '정답이에요!' : '오답이에요'}</ResultLabel>
            <ResultText>{resultText}</ResultText>
          </TextGroup>
        </motion.div>
      </ContentArea>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: BUTTON_DELAY_S, duration: 0.25, ease: 'easeOut' }}
      >
        <BackButton onClick={() => onBack(true)}>에너지 받기</BackButton>
      </motion.div>
    </StepWrapper>
  )
}
